import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';

import HeaderApp from '../../apps/HeaderApp/HeaderApp';
import { ToastContainerConfig } from '../../apps/MapApp/components/Toast/ToastNotification';

import '../../../scss/global.scss';
import '../../../scss/layout.scss';

import MapApp from '../../apps/MapApp/MapApp';

export default (i18n: any) => {
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const mapRoot = document.getElementById('map-root');

  // Mount toast container client-side only (not SSR) to avoid hydration mismatch
  const toastRoot = document.createElement('div');
  document.body.appendChild(toastRoot);
  createRoot(toastRoot).render(<ToastContainerConfig />);

  // Header is server side rendered in express-react library
  hydrateRoot(headerRoot!, <HeaderApp headerConfig={headerConfig} />);

  hydrateRoot(
    mapRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <MapApp environment={environment} />
    </I18nContextProvider>,
  );
};
